module.exports = __webpack_public_path__ + "static/img/slider5.794d44db.jpg";